import { render, staticRenderFns } from "./colonne_identifiant.vue?vue&type=template&id=f866371a"
import script from "./colonne_identifiant.js?vue&type=script&lang=js&external"
export * from "./colonne_identifiant.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports